/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */
// import Global from './global';

'use strict';
const LogosList = {

	$domLogoListWrapper: $('.js-logos-list__logo-wrapper'),
	$domLogoListBtn: $('.js-logo-list-btn'),
	$domLogosContainer: $('.js-logos-list__logo-container'),
	classLogoListWrapperExpand: 'logos-list__logo-wrapper--expand',

	init: function() {
		this.expandLogoWrapper();
		this.showHideBtn();
	},

	expandLogoWrapper: () => {
		let clicks = 0;
		LogosList.$domLogoListBtn.on('click', function() {
			LogosList.$domLogoListWrapper.toggleClass(LogosList.classLogoListWrapperExpand);
			if (clicks === 0) {
				$(this).text('View less');
				clicks = 1;
			} else if (clicks === 1) {
				$(this).text('View all');
				const offsetTop = $('.js-logos-list').offset().top;
				$('body,html').animate({
					scrollTop: offsetTop - 112
				}, 2000);
				clicks = 0;
			}
		});
	},

	showHideBtn: () => {
		LogosList.$domLogosContainer.each(function(e) {
			if (e <= 9) {
				LogosList.$domLogoListBtn.css('display', 'none');
			} else {
				LogosList.$domLogoListBtn.css('display', 'flex');
			}
		});
	},
};

export default LogosList;
